import React, { Fragment } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import profileIcon from "../../../assets/images/user.jpg";
import { Link, withRouter } from "react-router-dom";
import Select from "react-select";
import ReactCrop from "react-image-crop";
import ModalBox from "../../../components/shared/pageComponent/ModalBox";
import { getUsersTalents, getUsersGenre } from "../../../api/users";
import { userUpdate, userDetail } from "../../../api/admin";
import { uploadViaPresign } from "../../../api/upload";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Numbers, Text } from "../../../constants/constant";
import LocationSearchInput from "./LocationSearchInput";
class EditProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullname: "",
      email: "",
      bio: "",
      locationLabel: "",
      website_links: null,
      // The rest of the producer profile — previously unreachable from staff-side
      // (2026-07-15: "poder completar el perfil del productor en el admin").
      // Media fields hold S3 keys once uploaded; `*_preview` holds the absolute
      // URL to show, since the detail endpoint returns resolved URLs but the
      // save expects keys.
      instagram_url: "",
      tiktok_url: "",
      soundcloud_url: "",
      cover_image: undefined,
      cover_image_preview: null,
      video_url: undefined,
      video_url_preview: null,
      uploading: null,
      urls: null,
      video_links: [],
      selectedOption: null,
      src: null,
      croppedImageUrl: null,
      isModalOpen: false,
      place: null,
      genre: [],
      talents: [],
      select_genre: [],
      select_talents: [],
      userDetails: {},
      location: null,
      state: null,
      city: null,
      latitude: null,
      longitude: null,
      address: [],
      zipcode: "",
      profile_image: null,

      crop: {
        unit: "%",
        width: Numbers.thrt,
        aspect: Numbers.one,
      },
      is_address: true,
      onLocationLoad: false,
    };
  }

  async componentDidMount() {
    this.props.setLoading(true);
    this.props.setTitlePage("User Management");
    const Id = this.props.location.pathname.split("/edit-profile/");
    this.setState({ userId: Id[1] });
    const userData = await this.props.userDetail(Id[1]);
    if (userData && userData.data) {
      this.setState({
        userDetails: userData,
        email: userData.data.email,
        fullname: userData.data.name,
        bio: userData.data.bio,
        location: userData.data.city,
      });
      let genre = [];
      let roles = [];
      userData.data.genres.length &&
        userData.data.genres.forEach((element) => {
          genre.push({ value: element.id, label: element.title });
        });
      userData.data.roles.length &&
        userData.data.roles.forEach((element) => {
          roles.push({ value: element.id, label: element.title });
        });
      this.setState({
        website_links: userData.data.website_url,
        video_links:
          userData.data.video_links === null ? [] : userData.data.video_links,
        profile_image: userData.data.profile_image,
        instagram_url: userData.data.instagram_url || "",
        tiktok_url: userData.data.tiktok_url || "",
        soundcloud_url: userData.data.soundcloud_url || "",
        // Previews are absolute URLs from the API; the matching `cover_image` /
        // `video_url` stay undefined until staff pick a new file, so an
        // untouched field is omitted from the save and left alone server-side.
        cover_image_preview: userData.data.cover_image || null,
        video_url_preview: userData.data.video_url || null,
      });
      if (userData.data.latitude) {
        this.setState({
          locationLabel: `${userData.data.city}, ${userData.data.state}`,
          latitude: userData.data.latitude,
          longitude: userData.data.longitude,
        });
      }
      this.setState({
        croppedImageUrl: userData.data.profile_image,
        select_genre: genre,
        select_talents: roles,
        city: userData.data.city,
        state: userData.data.state,
      });
      await this.getTalent();
      await this.getGenre();
    } else {
      this.props.setLoading(false);
    }
    this.setState({ onLocationLoad: true });
  }

  getTalent = async () => {
    const data = await this.props.getUsersTalents();
    this.props.setLoading(false);
    if (data) {
      let tal = [];
      data.forEach((element) => {
        tal.push({ value: element.id, label: element.title });
      });
      this.setState({ talents: tal });
    }
  };

  getGenre = async () => {
    const data = await this.props.getUsersGenre();
    this.props.setLoading(false);
    if (data && data.length) {
      let gen = [];
      data.forEach((element) => {
        gen.push({ value: element.id, label: element.title });
      });
      this.setState({ genre: gen });
    }
  };

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > Numbers.zero) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ src: reader.result, isModalOpen: true })
      );
      reader.readAsDataURL(e.target.files[Numbers.zero]);
    }
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      Numbers.zero,
      Numbers.zero,
      crop.width,
      crop.height
    );

    let $this = this;
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        $this.setState({
          blob: blob,
        });
        resolve(this.fileUrl);
      }, "image/jpeg");
    });
  }

  handleAction = (action) => {
    if (action === "cancel") {
      this.setState({ croppedImageUrl: this.state.profile_image });
      this.imageRef = "";
    }
    this.setState({ isModalOpen: false });
  };

  validateData = (talentsIds, genreIds) => {
    if (talentsIds.length === 0) {
      document
        .getElementsByClassName(Text.formControl)[0]
        .classList.add("error");
    } else {
      document
        .getElementsByClassName(Text.formControl)[0]
        .classList.remove("error");
    }
    if (genreIds.length === 0) {
      document
        .getElementsByClassName(Text.formControl)[1]
        .classList.add("error");
    } else {
      document
        .getElementsByClassName(Text.formControl)[1]
        .classList.remove("error");
    }
  };

  videoLinks = (data) => {
    if (typeof data.video_links === "object") {
      return data.video_links;
    } else if (data.video_links !== "") {
      return [data.video_links];
    }
    return [];
  };

  createData = async (data) => {
    return {
      name: data.fullname,
      bio: data.bio,
      city: data.city,
      state: data.state,
      // `zipcode` is deliberately NOT sent. The form initialises it to "", never
      // prefills it from the API and renders no input for it, so including it
      // wrote an empty string over the stored value on every single save — a
      // silent data loss that also broke the admin's own zipcode list filter.
      latitude: data.latitude,
      longitude: data.longitude,
      profile_image:
        data.profile_image && data.profile_image.includes("https://")
          ? data.profile_image.split("s3.amazonaws.com")[1]
          : data.profile_image,
      // Sent ONLY when non-empty. `AdminUpdateUserSchema` declares both as
      // `.min(1)`, deliberately — an empty array used to WIPE the user's set —
      // so emitting `[]` here 400'd every account with no roles, or whose
      // assignable genres filtered down to nothing. Omitting the key leaves the
      // existing values untouched, which is what "I didn't change this" means.
      ...(Array.isArray(data.genreIds) && data.genreIds.length ? { genreIds: data.genreIds } : {}),
      ...(Array.isArray(data.talentsIds) && data.talentsIds.length
        ? { roleIds: data.talentsIds }
        : {}),
      website_url: data.website_links,
      video_links: await this.videoLinks(data),
      instagram_url: data.instagram_url,
      tiktok_url: data.tiktok_url,
      soundcloud_url: data.soundcloud_url,
      // Only sent when staff actually picked a new file — `undefined` keys are
      // dropped by the adapter, so an untouched cover/video is left as-is.
      cover_image: data.cover_image,
      video_url: data.video_url,
    };
  };

  /** Upload a picked file via the presigned flow and stash its S3 key. */
  handleProfileFile = async (e, field, kind) => {
    const file = e.target.files[0];
    if (!file) return;
    this.setState({ uploading: field });
    try {
      const key = await uploadViaPresign(file, kind);
      this.setState({ [field]: key, [`${field}_preview`]: null });
      toast("Uploaded", { type: "success" });
    } catch (error) {
      toast((error && error.message) || "Upload failed", { type: "error" });
    } finally {
      this.setState({ uploading: null });
    }
  };

  validateWebsiteUrl(url) {
    var isValidUrl = false;
    if (url.length > 0) {
      var p =
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
      if (url.match(p)) {
        isValidUrl = true;
      }
    }
    return isValidUrl;
  }

  validateYoutubeUrl(url) {
    const p =
      /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    return url.map((res) => {
      if (!res) return true;
      return res.match(p) ? true : false;
    });
  }
  validateVimeoUrl(url) {
    const p = /(?:https?:\/\/(?:www\.)?)?vimeo.com\/(?:channels\/|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
    return url.map((res) => {
      if (!res) return true;
      return res.match(p) ? true : false;
    });
  }

  updateUser = async () => {
    const {
      fullname,
      bio,
      city,
      state,
      latitude,
      longitude,
      profile_image,
      video_links,
      website_links,
      select_talents,
      select_genre,
      userId,
      is_address,
    } = this.state;
    let talentsIds = [];
    let genreIds = [];
    if (!is_address) {
      toast("Location is required!", { type: "error" });
      return;
    }
    this.props.setLoading(true);
    if (website_links) {
      const isValid = this.validateWebsiteUrl(website_links);
      if (isValid === false) {
        toast("Website url is not correct!", { type: "error" });
        this.props.setLoading(false);
        return false;
      }
    }
    const filteredEmptyString =
      video_links.length && video_links.filter(Boolean);
    if (filteredEmptyString.length > 0) {
      const isValid =
        this.validateYoutubeUrl(video_links) ||
        this.validateVimeoUrl(video_links);
      const getFalse = isValid.includes(false);
      if (getFalse) {
        toast("Video url is not correct!", { type: "error" });
        this.props.setLoading(false);
        return false;
      }
    }

    // Location is NOT required. `latitude` is only ever set by picking a city in
    // the Places autocomplete, and the app's own profile editor never sets it at
    // all (PATCH /users/me has no latitude/longitude), so every account created
    // in the app has latitude = null. Requiring it here blocked staff from saving
    // ANY change — name, bio, avatar, socials — to those accounts.
    if (select_talents && select_talents.length) {
      select_talents.forEach((element) => {
        talentsIds.push(element.value);
      });
    }
    if (select_genre && select_genre.length) {
      // Keep only ids that are actually assignable. A user may already carry a
      // legacy genre, which prefills the control but is not in the options list;
      // sending it back would now be rejected and block an otherwise unrelated
      // save. The API preserves those legacy rows either way.
      const assignable = new Set(this.state.genre.map((g) => g.value));
      select_genre.forEach((element) => {
        if (assignable.has(element.value)) genreIds.push(element.value);
      });
    }
    await this.validateData(talentsIds, genreIds);
    const updated_video_links = video_links.filter((item) => item !== "");
    const params = {
      fullname,
      bio,
      city,
      state,
      latitude,
      longitude,
      profile_image,
      genreIds,
      talentsIds,
      video_links: updated_video_links,
      website_links,
    };
    let data = await this.createData(params);
    let userApi = await this.props.userUpdate(userId, data);
    if (userApi && userApi.status === 200) {
      toast("Profile updated", { type: "success" });
      this.props.history.goBack();
    } else {
      // The API's error body is `{statusCode, timestamp, message}` — there is no
      // `msg`, so this used to call `toast(undefined)` and render NOTHING. A
      // rejected save looked exactly like a save that did nothing.
      const body = userApi && userApi.data;
      toast((body && (body.message || body.msg)) || "Couldn't save this profile.", {
        type: "error",
      });
    }
    this.setState({ loaded: false });
    this.props.setLoading(false);
  };

  handleChange = (e) => {
    const { value, name } = e.target;
    this.setState({ [name]: value });
    if (e.target.value === "") {
      e.target.classList.add("error");
    } else {
      e.target.classList.remove("error");
    }
  };

  selectTalents = (selections) => {
    this.setState({ select_talents: selections });
  };

  selectGenre = (selections) => {
    this.setState({ select_genre: selections });
  };

  navigateToDetails = () => {
    this.props.history.push(`/user-detail/${this.state.userId}`);
  };

  // Uploads the cropped avatar through the presigned flow. This used to read
  // raw IAM keys from `awsCredentials.s3`, but `getAwsCredentials` is a stub
  // returning `false` — and unlike the headline form this had no try/catch, so
  // it threw on `.s3` of `false` and the avatar simply never uploaded.
  uploadImageOns3 = async () => {
    this.props.setLoading(true);
    this.setState({ isModalOpen: false });
    try {
      const blob = this.state.blob;
      const fileName = `BassParlour_${new Date().getTime()}.jpg`;
      // The cropper hands back a Blob; presign needs a File (it reads `.type`).
      const file = new File([blob], fileName, { type: blob.type || "image/jpeg" });
      const key = await uploadViaPresign(file, "profile");
      this.setState({ profile_image: key });
      toast("Avatar uploaded — press Update to save", { type: "success" });
    } catch (error) {
      toast((error && error.message) || "Upload failed", { type: "error" });
    } finally {
      this.props.setLoading(false);
    }
  };

  selectedLocation = (val, item) => {
    if (item) {
      const locationData = val.split(",");
      this.setState({
        locationLabel: `${locationData[0]}, ${locationData[1]}`,
        latitude: item.lat,
        longitude: item.lng,
        city: locationData[0],
        state: locationData[1],
      });
    }
  };
  handleVideoUrlListChange = (index, event) => {
    var videos = this.state.video_links.slice();
    videos[index] = event.target.value;
    this.setState({ video_links: videos });
  };
  handleVideoUrlChange = (event) => {
    this.setState({
      video_links: [...this.state.video_links, event.target.value],
    });
  };
  removeUrl = (index, event) => {
    var videos = this.state.video_links.slice();
    videos[index] = "";
    this.setState({ video_links: videos });
  };

  isAddress = (data) => {
    if (data) {
      this.setState({ is_address: true });
    } else {
      this.setState({ is_address: false });
    }
  };

  render() {
    const {
      fullname,
      bio,
      email,
      website_links,
      video_links,
      src,
      crop,
      croppedImageUrl,
      talents,
      genre,
      select_genre,
      select_talents,
      locationLabel,
      onLocationLoad,
      userId,
      instagram_url,
      tiktok_url,
      soundcloud_url,
      cover_image,
      cover_image_preview,
      video_url,
      video_url_preview,
      uploading,
    } = this.state;
    return (
      <>
        <div className="header-section">
          <div className="title-wrap">
            <h3>User Details</h3>
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to="/user-list">User Listings</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to={`/user-detail/${userId}`}>User Details</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>Edit Profile</BreadcrumbItem>
            </Breadcrumb>
          </div>
        </div>
        <div></div>
        <ModalBox
          isOpen={this.state.isModalOpen}
          withHeader={true}
          ModalTitle="Upload Image"
          toggle={this.toggleModal}
          className="modal-crop"
        >
          {src && (
            <Fragment>
              {" "}
              <ReactCrop
                src={src}
                crop={crop}
                ruleOfThirds
                onImageLoaded={this.onImageLoaded}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
              />
              <div className="action-wrap">
                <Button
                  color="secondary"
                  onClick={() => this.handleAction("cancel")}
                >
                  Cancel
                </Button>
                <Button color="primary" onClick={this.uploadImageOns3}>
                  Ok
                </Button>
              </div>
            </Fragment>
          )}
        </ModalBox>
        <div className="white-bg-row wide">
          <Form className="profile-form">
            <FormGroup className="file-field">
              <figure className="pofile-pic">
                <img
                  src={croppedImageUrl ? croppedImageUrl : profileIcon}
                  alt="profile icons"
                  width="80"
                  height="80"
                />
              </figure>
              <span className="edit-pic">
                <Input
                  type="file"
                  name="file"
                  id="exampleFile"
                  onChange={this.onSelectFile}
                />
              </span>
            </FormGroup>
            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Full Name</Label>
                  <Input
                    type="text"
                    name="fullname"
                    id="fullname"
                    onChange={this.handleChange}
                    value={fullname}
                    placeholder="Enter Full Name"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Email</Label>
                  <Input
                    type="email"
                    name="email"
                    id="userEmail"
                    value={email}
                    disabled
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col xs={12}>
                <FormGroup>
                  <label htmlFor="bio">Bio</label>
                  <Input
                    id="bio"
                    name="bio"
                    style={{ height: 100 }}
                    maxLength="1000"
                    type="textarea"
                    onChange={this.handleChange}
                    value={bio}
                    placeholder="Enter Bio"
                  />
                </FormGroup>
              </Col>
            </Row>
            <strong className="form-title">Location</strong>
            <Row form>
              <Col xs={6}>
                <FormGroup className="location">
                  <Label for="exampleCity">Location</Label>
                  {onLocationLoad && (
                    <LocationSearchInput
                      selectedLocation={(data, getLatLngs) =>
                        this.selectedLocation(data, getLatLngs)
                      }
                      ApiAddress={locationLabel}
                      isAddress={(data) => this.isAddress(data)}
                    />
                  )}
                </FormGroup>
              </Col>
            </Row>
            <strong className="form-title">Interest</strong>
            <Row form>
              <Col xs={6}>
                <FormGroup>
                  <Label for="exampleCity">Music Talent</Label>
                  <Select
                    value={select_talents}
                    onChange={this.selectTalents}
                    options={talents}
                    isMulti
                    className={Text.formControl}
                  />
                </FormGroup>
              </Col>
              <Col xs={6}>
                <FormGroup>
                  <Label for="exampleState">Music Genre</Label>
                  <Select
                    value={select_genre}
                    onChange={this.selectGenre}
                    options={genre}
                    isMulti
                    className={Text.formControl}
                  />
                </FormGroup>
              </Col>
              <Col xs={6}>
                <FormGroup>
                  <Label for="exampleZip">Website</Label>
                  <Input
                    type="text"
                    name="website_links"
                    id="Website"
                    onChange={this.handleChange}
                    value={website_links}
                    placeholder="Enter Website"
                  />
                </FormGroup>
              </Col>
            </Row>

            {/* Social links + cover/intro media — the remainder of what a
                producer can set on themselves in the app. Staff could not touch
                any of it before, so a profile could not be completed here. */}
            <Row>
              <Col xs={4}>
                <FormGroup>
                  <Label for="instagram">Instagram</Label>
                  <Input
                    type="text"
                    name="instagram_url"
                    id="instagram"
                    onChange={this.handleChange}
                    value={instagram_url}
                    placeholder="Instagram handle or URL"
                  />
                </FormGroup>
              </Col>
              <Col xs={4}>
                <FormGroup>
                  <Label for="tiktok">TikTok</Label>
                  <Input
                    type="text"
                    name="tiktok_url"
                    id="tiktok"
                    onChange={this.handleChange}
                    value={tiktok_url}
                    placeholder="TikTok handle or URL"
                  />
                </FormGroup>
              </Col>
              <Col xs={4}>
                <FormGroup>
                  <Label for="soundcloud">SoundCloud</Label>
                  <Input
                    type="text"
                    name="soundcloud_url"
                    id="soundcloud"
                    onChange={this.handleChange}
                    value={soundcloud_url}
                    placeholder="SoundCloud handle or URL"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col xs={6}>
                <FormGroup>
                  <Label>Cover Image</Label>
                  <Input
                    type="file"
                    accept="image/*"
                    disabled={uploading === "cover_image"}
                    onChange={(e) =>
                      this.handleProfileFile(e, "cover_image", "poster")
                    }
                  />
                  {uploading === "cover_image" && <FormText>Uploading…</FormText>}
                  {cover_image && <FormText>Uploaded ✓ (saves on Update)</FormText>}
                  {!cover_image && cover_image_preview && (
                    <FormText>
                      <a
                        href={cover_image_preview}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Current cover
                      </a>{" "}
                      — pick a file to replace it.
                    </FormText>
                  )}
                </FormGroup>
              </Col>
              <Col xs={6}>
                <FormGroup>
                  <Label>Intro Video</Label>
                  <Input
                    type="file"
                    accept="video/*"
                    disabled={uploading === "video_url"}
                    onChange={(e) =>
                      this.handleProfileFile(e, "video_url", "video")
                    }
                  />
                  {uploading === "video_url" && <FormText>Uploading…</FormText>}
                  {video_url && <FormText>Uploaded ✓ (saves on Update)</FormText>}
                  {!video_url && video_url_preview && (
                    <FormText>
                      <a
                        href={video_url_preview}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Current intro video
                      </a>{" "}
                      — pick a file to replace it.
                    </FormText>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <strong className="form-title">Youtube & Vimeo URL</strong>
            <Label for="exampleAddress">URL</Label>
            {video_links && video_links.length ? (
              video_links.map((val, index) => (
                <FormGroup className="video-url" key={index}>
                  <Input
                    type="text"
                    placeholder="Enter video url"
                    onChange={this.handleVideoUrlListChange.bind(this, index)}
                    value={val}
                  />
                  {val ? (
                    <span
                      className="remove"
                      onClick={this.removeUrl.bind(this, index)}
                    >
                      Remove
                    </span>
                  ) : (
                    ""
                  )}
                </FormGroup>
              ))
            ) : (
              <FormGroup className="video-url">
                <Input
                  type="text"
                  name="video_links"
                  id="vidUrl"
                  placeholder="Enter video url"
                  onChange={this.handleVideoUrlChange.bind(this)}
                />
              </FormGroup>
            )}

            <div className="action-wrap">
              <Button color="secondary" onClick={this.navigateToDetails}>
                Cancel
              </Button>
              <Button color="primary" onClick={this.updateUser}>
                Update
              </Button>
            </div>
          </Form>
        </div>
      </>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    admin: store.user,
  };
};

export default connect(mapStateToProps, {
  userDetail,
  getUsersTalents,
  getUsersGenre,
  userUpdate,
})(withRouter(EditProfile));
